export default __webpack_public_path__ + "static/media/timer.d41bd4d2.svg";